import React from 'react';
import moment from 'moment';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Camera from '../../components/Camera/Camera';
import RunningTime from '../../components/RunningTime/RunningTime';
import TextField from '@material-ui/core/TextField';
import Switch from '@material-ui/core/Switch';
import Input from '../../components/Input/Input';
import Button from '@material-ui/core/Button';
import axios from '../../config/axiosInstance';
import timeclockInstance from '../../config/timeclockInstance';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';

export class FinishActivity extends React.Component {
    state = {
        os: null,
        checked: false,
        dateTime: moment().format('YYYY-MM-DD HH:mm'),
        workActivityObs: null,
        inParentId: null,
    }

    registerActivity = async () => { //essa função via ir para o aquivo principal
        const jwt = require('jsonwebtoken');
        const decodedToken = jwt.decode(localStorage.token);
        const fetchResult = await timeclockInstance.get(`/record-reg/companies/${decodedToken.cpf}`); //requisição temporaria
        axios
            .post('workActivity', {
                companyId: decodedToken.companyId,
                customId: this.props.allActivities.filter(i => i.id == this.state.inParentId).map(i => i.customId)[0],
                byUser: decodedToken.id,
                employeeId: fetchResult.data.companies.find(e => e.employeeId).employeeId, // pegar variavel do decodedToken
                type: 'O',
                workActivityObs: this.state.workActivityObs,
                picturePath: this.camera.takePicture(),
                isManual: this.state.checked,
                dtRegister: (moment(this.state.dateTime, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm')),
                inParentId: this.state.inParentId,
            }, { headers: { Authorization: ` Bearer ${localStorage.token}` } })
            .then((response) => {
            })
            .catch((error) => {
                this.props.onMessage(error);
            });
        setTimeout(() => window.location.reload(), 1000);
    };

    handleChange = (event, type) => {
        let newDateTime = { ...this.state.dateTime };
        switch (type) {
            case 'customId':
                this.setState({ inParentId: event.target.value });
                break;

            case 'datetime':
                newDateTime = event;
                this.setState({ dateTime: newDateTime });
                break;

            case 'workActivityObs':
                this.setState({ workActivityObs: event.target.value });
                break;

            default:
                break;
        }
    };

    // filterOsEmployee = () => {
    //     let unfinished = this.props.allActivities.slice(0, -1).filter(i => i.inParentId == null)
    //     let finished = this.props.allActivities.slice(0, -1).filter(i => i.inParentId != null)
    //     let filterFinished = finished.filter((finished) => unfinished.find(finished => finished.inParentId != unfinished.id))
    //     let filterUnfinished = unfinished.filter((unfinished) => finished.find(finished => finished.inParentId != unfinished.id))
    //     let removeDuplicatesUnfinished = filterUnfinished.filter(({ customId }) => !finished.some(exclude => exclude.customId == customId))
    //     let results = filterFinished.concat(removeDuplicatesUnfinished);
    //     this.setState({ result: results });
    // }

    handleChangeDate = (event) => {
        this.setState({ [event.target.name]: event.target.checked });
        if (event.target.checked == false) {
            this.setState({ dateTime: moment().format('YYYY-MM-DD HH:mm') })
        } else { }
    };

    render() {

        const { classes, allActivities } = this.props;

        return (
            <Paper elevation={0}>
                <Typography style={{ textAlign: 'center' }}>Finalizar sua Atividade</Typography>
                <div style={{ textAlign: 'center', width: '100%' }}>
                    <Typography
                        variant="body1"
                        color="textSecondary"
                        paragraph
                    >
                        {/* {info}  nome do usuario */}
                    </Typography>
                    {/* <TextField
                        inputProps={{ maxLength: 15, style: { textTransform: "uppercase" } }}
                        elementType="text"
                        label="OS:"
                        margin="normal"
                        variant="outlined"
                        onChange={event => this.handleChange(event, 'customId')}
                        fullWidth
                    /> */}
                    <FormControl fullWidth style={{ marginBottom: '10px' }}>
                        <InputLabel htmlFor="age-simple">OS:</InputLabel>
                        <Select
                            required
                            // value={allActivities.filter(i => i.employee.name == localStorage.userName && i.inParentId == null).customId}
                            // value={allActivities.customId}
                            // allActivities.filter(i => i.employee.name == localStorage.userName && i.inParentId == null)
                            onChange={event => this.handleChange(event, 'customId')}
                        >
                            {
                                this.props.allActivities.filter(i => i.employee.name == localStorage.userName && i.inParentId == null).map(i => (
                                    <MenuItem key={i.id} value={i.id}>{i.customId}</MenuItem>
                                ))}
                        </Select>
                    </FormControl>
                    <Camera
                        innerRef={(node) => {
                            this.camera = node;
                        }} />
                </div>
                <div>
                    <Typography>
                        <Switch
                            checked={this.state.checked}
                            onChange={this.handleChangeDate}
                            color="primary"
                            name="checked"
                        />
                        Colocar data e hora Manualmente.
                    </Typography>

                    {!this.state.checked ? (<div style={{ textAlign: 'center' }}><RunningTime /></div>) :
                        <Input
                            elementType='dateTimePicker'
                            label="Data e Horário"
                            margin="normal"
                            variant="outlined"
                            value={this.state.dateTime}
                            onChange={event => this.handleChange(event, 'datetime')}
                            required
                            fullWidth
                        />}

                </div>
                <TextField
                    elementType="text"
                    label="Descrição (Opcional):"
                    margin="normal"
                    variant="outlined"
                    onChange={event => this.handleChange(event, 'workActivityObs')}
                    fullWidth
                />
                {!this.state.inParentId ?
                    (<div style={{ textAlign: 'center', marginBottom: '30px' }}>
                        <Button
                            disabled={true}
                            variant="contained"
                            style={{ width: '100%', backgroundColor: 'gray', color: '#fff' }}
                            onClick={() => this.registerActivity()}
                        >
                            FINALIZAR
                        </Button>
                    </div>)
                    :
                    < div style={{ textAlign: 'center', marginBottom: '30px' }}>
                        <Button
                            variant="contained"
                            style={{ width: '100%', backgroundColor: '#a70016', color: '#fff' }}
                            onClick={() => this.registerActivity()}
                        >
                            FINALIZAR
                        </Button>
                    </div>}
            </Paper >
        );
    }
}
export default FinishActivity;